export default __webpack_public_path__ + "static/media/uploadTw2.41448e24.png";